import { getLogger } from '@blueberry/observability'
import { Flow } from '../types'

declare global {
  interface Window {
    // microsoft/bing uet
    uetq: unknown[]
  }
}

const logger = getLogger('signup/analytics/bing_uet')

export const bing_uet = {
  trackSuccess(flow: Flow) {
    // we currently only use bing uet for d2c
    if (flow !== 'd2c') return

    try {
      window.uetq = window.uetq || []
      window.uetq.push('event', 'purchase', {})
    } catch (error) {
      logger.error('Error tracking Bing UET success event:', error)
      return
    }
  },
}
